module.exports = __webpack_public_path__ + "img/12.05cdeb26.jpg";